import React, { useEffect } from 'react'
import Register from '@/pages/register/register'
import { Storage } from '@bihu/common-js'
import { CACHED_URL_PARAMS } from '@/constants/storage'

interface Props{}
// 领取额度
const GetQuota:React.FC<Props> = () => {
  useEffect(() => {
    // 获取 URL 参数
    const urlParams = new URLSearchParams(window.location.search)
    const params: Record<string, string> = {}

    urlParams.forEach((value, key) => {
      if (value) {
        params[key] = value
      }
    })

    // 如果存在参数，缓存它们
    if (Object.keys(params).length > 0) {
      Storage.set(CACHED_URL_PARAMS, params)
    }

  }, [])

  return (
    <Register type="getQuota" />
  )
}

export default GetQuota